module.exports = __webpack_public_path__ + "static/media/amazon-alexa.40c8b904.jpg";